/**
 * UUID v4 — the shape Postgres `gen_random_uuid()` produces for resource IDs.
 * Shared so callers that detect, validate, or compose around UUID-shaped
 * strings stay consistent.
 */
export const UUID_V4_PATTERN =
  "[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}";

export const UUID_V4_REGEX = new RegExp(`^${UUID_V4_PATTERN}$`);
